import React, { useCallback } from 'react';
import { Controller } from 'react-hook-form';
import RCSelect from 'react-select';
import colors from '../../assets/themes/colors';
import InputFeedback from '../InputFeedback/index.web';

const Select = ({
  name,
  control,
  label,
  placeholder,
  items,
  className,
  disabled,
  loading,
  error,
}: Select.Props) => {
  const getLabel = useCallback(
    (value: string) => {
      const option = items.find((item) => item.value === value);

      if (option) {
        return option;
      }

      return null;
    },
    [items]
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <div className={className}>
          <div className={error ? '' : 'mb-[27px]'}>
            <div className="mb-2 text-xs text-gray-400">{label}</div>

            <RCSelect
              placeholder={placeholder}
              options={items}
              isLoading={loading}
              isDisabled={disabled || loading}
              menuPosition={'fixed'}
              menuPortalTarget={document.body}
              styles={{
                placeholder: (baseStyles) => ({
                  ...baseStyles,
                  color: error ? colors.feedback.error.text : colors.gray[400],
                }),
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  boxShadow: 'none',
                  borderRadius: 8,
                  padding: '6px 7px',
                  borderWidth: 1.5,
                  borderColor: error
                    ? colors.feedback.error.main
                    : state.isFocused
                    ? colors.primary[600]
                    : colors.secondary[400],
                  fontSize: 14,
                  fontFamily: state.hasValue
                    ? 'PlutoSansMedium'
                    : 'PlutoSansRegular',
                  backgroundColor: error
                    ? colors.feedback.error.bkg
                    : undefined,
                }),
                option: (baseStyles) => ({
                  ...baseStyles,
                  fontSize: 14,
                }),
              }}
              value={getLabel(value)}
              onChange={(newValue) => onChange(newValue?.value)}
            />

            <InputFeedback message={error} />
          </div>
        </div>
      )}
    />
  );
};

export default Select;
